import { Home, NotFound, Todos, Factory, AddProduct, Products, WorkOrder, ViewWorkOrder, EnamelPaintingWorkOrder, FormTracking } from '../pages';
import { ViewEnamelPaintingWorkOrder } from '../pages/FormPages';

const routes = [
    {
        title: 'Ana Sayfa',
        path: '/',
        exact: true,
        element: <Home />,
        children: [],
        isPrivate: false
    },
    {
        title: 'Fabrika',
        path: '/factory',
        exact: true,
        element: <Factory title="Fabrika"/>,
        children: [],
        isPrivate: true, 
    },
    {
        title: 'Todos',
        path: '/todos',
        exact: true,
        element: <Todos />,
        children: [],
        isPrivate: false
    },
    {
        title: 'Sayfa Bulunamadı',
        path: '*',
        exact: true,
        element: <NotFound />,
        children: [],
        isPrivate: false
    },
    {
        title: 'Ürün Ekle',
        path: '/factory/add-product',
        exact: true,
        element: <AddProduct title="Ürün Ekle"/>,
        children: [],
        isPrivate: true,
    },
    {
        title: 'Ürün Düzenle',
        path: '/factory/edit-product/:id',
        exact: true,
        element: <AddProduct title="Ürün Düzenle"/>,
        children: [],
        isPrivate: true,
    }, 
    {
        title: 'Ürünler',
        path: '/factory/products',
        exact: true,
        element: <Products title="Ürünler"/>,
        children: [],
        isPrivate: true,
    }, 
    {
        title: 'İş Emri Takip Formu',
        path: '/factory/work-order',
        exact: true,
        element: <WorkOrder title="İş Emri Takip Formu"/>,
        children: [],
        isPrivate: true,
    }, 
    {
        title: 'İş Emri Takip Formu',
        path: '/factory/view-work-order/:id',
        exact: true,
        element: <ViewWorkOrder title="İş Emri Takip Formu Görüntüleme"/>,
        children: [],
        isPrivate: true,
    }, 
    {
        title: 'Emaye Boyama İş Emri Takip Formu',
        path: '/factory/enamel-painting-work-order',
        exact: true,
        element: <EnamelPaintingWorkOrder title="Emaye Boyama İş Emri Takip Formu"/>,
        children: [],
        isPrivate: true,
    }, 
    {
        title: 'Emaye Boyama İş Emri Takip Formu Görüntüleme',
        path: '/factory/view-enamel-painting-work-order/:id',
        exact: true,
        element: <ViewEnamelPaintingWorkOrder title="Emaye Boyama İş Emri Takip Formu Görüntüleme"/>,
        children: [],
        isPrivate: true,
    }, 
    {
        title: 'Form Takip Sayfası',
        path: '/factory/form-tracking',
        exact: true,
        element: <FormTracking title="Form Takip Sayfası"/>,
        children: [],
        isPrivate: true,
    }
];

export default routes;
